import React, { useEffect, useState } from 'react'
import Modal from '../../components/shared/Modal';
import TextInput from '../../components/InputComponent/TextInput';
import toast from 'react-hot-toast';

export default function SettingsModal({ isOpen, onClose, onSave, isLoading, editData }) {
    const initData = {
        key: "",
        value: ""
    };
    const [formData, setFormData] = useState(initData);

    useEffect(() => {  
        if (editData?.key != null) {
            setFormData(editData)
        } else {
            setFormData(initData)
        }
    }, [editData, isOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.key || !formData.value) {
            toast.error('Please fill all required fields.');
            return;
        }
        setFormData(initData)
        onSave(formData, { isEdit: true });

    }
    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Create Settings">
            <form onSubmit={handleSubmit} className="space-y-4">
                <TextInput disabled={!!editData?.key} label={"Key"} name='key' type="text" value={formData.key} onChange={handleChange} isRequired={!editData?.key}/>
                <TextInput label={'Value'} name='value' type="text" value={formData.value} onChange={handleChange} isRequired={true}/>
                 
                <div className="pt-4 flex justify-end gap-3">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Cancel</button>
                    <button type="submit" disabled={isLoading} className="px-4 py-2 bg-brand-green text-white rounded-lg hover:bg-green-600">{isLoading ? "Loading..." : 'Save Settings'}</button>
                </div>
            </form>
        </Modal>
    )
}
